import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./header/header";
import Footer from "./Footer";
import ContactModern from "./Contact";
import AboutFull from "./about/AboutFull";
import NotFoundPage from "./NotFoundPage";
import ProcessPage from "./process/ProcessPage";
import ProductsPage from "./products/Products";
import ServiceDetails from "./services/ServiceDetails";
import Lenis from "@studio-freight/lenis";

function MainLayout() {

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.9,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      wheelMultiplier: 2,
      touchMultiplier: 3,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>

      <Header />

      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/contact" element={<ContactModern />} />
        <Route path="/about" element={<AboutFull />} />
        <Route path="/work" element={<ProcessPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/service/:serviceId" element={<ServiceDetails />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Footer />

    </BrowserRouter>
  );
}


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <MainLayout />
  </React.StrictMode>
);

reportWebVitals();